import { InsertionOrder } from '../../../redux/billing/billing.types';

export type InsertionOrderDisplayStatus =
  | 'draft'
  | 'sent'
  | 'completed'
  | 'declined'
  | 'expired'
  | 'revoked'
  | 'delivery_failed'
  | 'send_failed';

const TERMINAL_BOLDSIGN_STATUSES: InsertionOrderDisplayStatus[] = [
  'declined',
  'expired',
  'revoked',
  'delivery_failed',
  'send_failed',
];

export function getInsertionOrderDisplayStatus(order: InsertionOrder): InsertionOrderDisplayStatus {
  if (order.boldsign_status && TERMINAL_BOLDSIGN_STATUSES.includes(order.boldsign_status as InsertionOrderDisplayStatus)) {
    return order.boldsign_status as InsertionOrderDisplayStatus;
  }

  if (order.client_signed && order.agency_signed) {
    return 'completed';
  }

  if (order.is_active) {
    return 'sent';
  }

  return 'draft';
}

export function formatInsertionOrderStatusLabel(status: InsertionOrderDisplayStatus): string {
  switch (status) {
    case 'delivery_failed':
      return 'Delivery failed';
    case 'send_failed':
      return 'Send failed';
    default:
      return status.charAt(0).toUpperCase() + status.slice(1);
  }
}

export function getInsertionOrderStatusBadgeVariant(
  status: InsertionOrderDisplayStatus
): 'blue' | 'green' | 'red' | 'gray' {
  switch (status) {
    case 'draft':
      return 'gray';
    case 'sent':
      return 'blue';
    case 'completed':
      return 'green';
    default:
      return 'red';
  }
}

export function getInsertionOrderStatusColor(status: InsertionOrderDisplayStatus, isDot = false): string {
  switch (status) {
    case 'draft':
      return isDot ? 'bg-gray-600' : 'text-gray-500';
    case 'sent':
      return isDot ? 'bg-blue-500' : 'text-blue-500';
    case 'completed':
      return isDot ? 'bg-[#31BB64]' : 'text-[#31BB64]';
    case 'declined':
    case 'expired':
    case 'revoked':
    case 'delivery_failed':
    case 'send_failed':
      return isDot ? 'bg-red-500' : 'text-red-600';
    default:
      return isDot ? 'bg-gray-600' : 'text-gray-600';
  }
}
